module.exports = __webpack_public_path__ + "img/hero-lg.24e23897.png";